<ng-container *ngIf="isLoading; else content">
  <div fxFill fxLayout="column" fxLayoutAlign="center center">
    <mat-spinner [diameter]="diameter || 50"></mat-spinner>
  </div>
</ng-container>

<ng-template #content>
  <ng-content></ng-content>
</ng-template>
